(() => {
  // Reviews often store a translation after a run of equals signs.
  // That string does not wrap, so line-clamp never clips the card.
  const SEPARATOR = /={4,}/g;

  function splitSeparators(root) {
    if (!root || root.dataset.translationSplit === 'true') return;
    root.dataset.translationSplit = 'true';

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach((textNode) => {
      const value = textNode.nodeValue || '';
      if (!/={4,}/.test(value)) return;

      const parts = value.split(/={4,}/);
      const fragment = document.createDocumentFragment();
      parts.forEach((part, index) => {
        if (index > 0) {
          const rule = document.createElement('span');
          rule.className = 'review-translation-break';
          rule.setAttribute('aria-hidden', 'true');
          fragment.appendChild(rule);
        }
        if (part) fragment.appendChild(document.createTextNode(part));
      });
      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function initExpandable(container) {
    const content = container.querySelector('.metafield-rich_text_field');
    const button = container.querySelector('.recent-customer-review-toggle');
    if (!content || !button || container.dataset.reviewReady === 'true') return;
    container.dataset.reviewReady = 'true';

    splitSeparators(content);

    const isClamped = content.scrollHeight > content.clientHeight + 1;
    if (!isClamped) return;

    button.style.display = 'inline-block';
    button.addEventListener('click', () => {
      const isExpanded = container.classList.toggle('is-expanded');
      button.textContent = isExpanded ? 'Read less' : 'Read more';
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  }

  function boot() {
    document
      .querySelectorAll(
        '.recent-customer-review-content .metafield-rich_text_field, .review-content .metafield-rich_text_field, .testimonial__content .metafield-rich_text_field'
      )
      .forEach(splitSeparators);

    document.querySelectorAll('.recent-customer-review-content--expandable').forEach(initExpandable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
